<template>
    <div
        :class="$style.app_link"
        :data-interface-target="badge.interfaceTarget"
        role="button"
        tabindex="0"
        :aria-label="$tr('navigation.app_link')"
        @click="onClick"
        @keydown.enter.space.prevent="onClick"
    >
        <img
            :src="badge.img"
            :alt="badge.alt"
            loading="lazy"
            :class="[$style.app_badge, badge.isIos ? $style.app_badge_ios : $style.app_badge_android]"
        />
        <Typography
            size="s"
            :class="$style.app_link_desc"
            accent
        >
            {{ $tr('navigation.app_link') }}
        </Typography>
        <Icon
            name="chevron-right"
            :class="$style.app_link_icon"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Icon from '@/components/Icon/Icon.vue'
import Typography from '@/components/Typography.vue'
import { CREATIVE_IDS, useGoToApp } from '@/composables/use-go-to-app'
import { useAppStore } from '@/store/app-store'

import AndroidAppBadgeImg from '../images/android_image.svg'
import IosAppBadgeImg from '../images/ios_image.svg'

const appStore = useAppStore()
const { goToApp } = useGoToApp(CREATIVE_IDS.FOOTER)

const badge = computed(() =>
    appStore.platform === 'ios'
        ? {
              isIos: true,
              img: IosAppBadgeImg,
              alt: 'Playgama iOS',
              interfaceTarget: 'app-install-badge-ios',
          }
        : {
              isIos: false,
              img: AndroidAppBadgeImg,
              alt: 'Playgama Android',
              interfaceTarget: 'app-install-badge-android',
          },
)

function onClick() {
    goToApp()
}
</script>

<style module>
.app_link {
    display: flex;
    padding: 8px;
    gap: 10px;
    background-color: var(--carbon-300);
    border-radius: 12px;
    align-items: center;
    cursor: pointer;
}

.app_badge {
    width: 126px;
}

.app_badge_android {
    aspect-ratio: 27 / 8;
}

.app_badge_ios {
    aspect-ratio: 3 / 1;
}

.app_link_icon {
    flex-shrink: 0;
    margin-left: auto;
    color: var(--white-20);
}

.app_link_desc {
    color: var(--white-80);
}

@media (--tablet-plus) {
    .app_link {
        height: 0;
        width: 0;
        visibility: hidden;
        overflow: hidden;
        padding: 0;
    }
}
</style>
